/**
 * AVT note section → form field routing for the FDMCA (Functional & Diagnostic
 * Mental Capacity Assessment).
 *
 * The section *titles* here are the join key; the matching descriptions (the
 * instructions pasted into Tortus) live next to this file in
 * `fdmca.avt-template.md`. Keep the titles in the two files in sync.
 *
 * Note the many-to-one cases — "Relevant background" and "Person's wishes,
 * feelings and concerns" both feed `additionalDecisionInformation`, joined in
 * the order below. The four functional-test radios, `impairmentDisturbance`,
 * and the `lackOfCapacity` verdict are intentionally absent: AVT drafts the
 * free-text reasoning only; the clinician makes the determinations.
 */
export const fdmcaAvtSections = [
    { title: "Decision being assessed", field: "decisionOutline" },
    { title: "Steps taken to support the decision", field: "supportSteps" },
    { title: "People involved in the assessment", field: "supportingPeople" },
    { title: "Relevant background", field: "additionalDecisionInformation" },
    {
        title: "Person's wishes, feelings and concerns",
        field: "additionalDecisionInformation",
    },
    { title: "Understanding the information", field: "reasoningUnderstand" },
    { title: "Retaining the information", field: "reasoningRetain" },
    { title: "Using or weighing the information", field: "reasoningUseAndWeigh" },
    { title: "Communicating the decision", field: "reasoningCommunicate" },
    {
        title: "Impairment or disturbance of mind or brain",
        field: "impairmentType",
    },
    { title: "Capacity reasoning", field: "reasoningLackOfCapacity" },
];
//# sourceMappingURL=fdmcaAvtSections.js.map